import { Product } from './product';

export class Order {
    id: string;
    customerId: string;
    customerEmail: string;
    date: any;
    subtotal: number;
    discountTotal: number;
    taxesTotal: number;
    otherCosts: number;
    total: number;
    cityCode: string;
    cityName: string;
    addres: string;
    neighborhood?: string;
    addresExtraInformation?: string;
    departamento?: string;
    departamentoCode?: string;
    orderDetail: Product[];
    orderStatus?: string;
    orderStatusId?: number;
    paymentMethod?: string;
    totalCostInPoints?: number;
    totalRevenuePoints?: number;




}